import { Page } from './page';

export enum CmsSiteType {
  BrandStore = 'BRAND_STORE',
  Product = 'PRODUCT',
}

export enum CmsEntityType {
  BaseEntity = 'baseEntity',
  Site = 'site',
  Page = 'page',
  Widget = 'widget',
  WidgetConfig = 'widgetConfig',
  Asset = 'asset',
}

export enum BrandclubCMSEntity {
  Audience = 'audience',
  Brand = 'brand',
  Campaign = 'campaign',
  CompanyDivision = 'companyDivision',
  Customer = 'customer',
  Product = 'product',
  Reward = 'reward',
  Profile = 'profile',
}

export enum PublishState {
  Draft = 'DRAFT',
  Published = 'PUBLISHED',
  Archived = 'ARCHIVED',
  Unpublished = 'UNPUBLISHED',
}

export interface Site {
  siteId: string;
  versionId: number;
  siteType: CmsSiteType.BrandStore;
  type: CmsEntityType.Site;
  publishState: PublishState;
  pages: Page[];
}
